import { PayoutType as BposPayoutType, PromoTokenType } from '@bpos/v1/my-bets';
import { PayoutType, RewardTokenType } from 'packages/sports/web/app/src/tokens-base/token-base.models';

export function convertTokenType(tokenType: PromoTokenType): RewardTokenType | undefined {
    switch (tokenType) {
        case PromoTokenType.AccaBoost:
            return RewardTokenType.AccaBoost;
        case PromoTokenType.OddsBoost:
            return RewardTokenType.OddsBoost;
        case PromoTokenType.BestOdds:
            return RewardTokenType.BestOddsGuaranteed;
        case PromoTokenType.RiskFree:
            return RewardTokenType.RiskFreeBet;
        default:
            return undefined;
    }
}
export function convertPayoutType(payoutType: BposPayoutType | undefined): PayoutType | undefined {
    switch (payoutType) {
        case BposPayoutType.FreeBet:
            return PayoutType.FreeBet;
        case BposPayoutType.Bonus:
            return PayoutType.Bonus;
        case BposPayoutType.Cash:
            return PayoutType.Cash;
        default:
            return undefined;
    }
}
